export { default } from './FormPlaceCategory.vue'
